import React, {useEffect, useState} from 'react'
import WhitePlus from '../../../../media/felsv/white_plus-small_icon.svg'
import WhiteCheck from '../../../../media/felsv/white_check_icon.svg'
import DarkPorcentaje from '../../../../media/felsv/Porcentaje.svg'
import SecondaryPorcentaje from '../../../../media/felsv/PorcentajeSecondary.svg'
import DarkDollar from '../../../../media/felsv/Dollar.svg'
import DollarSecondary from '../../../../media/felsv/DollarSecondary.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoProducto} from '../../../../actions/action-creators'
import InputIcon from '../../../../components/Inputs/InputIcon'
import SEDatosSucursal from './SEDatosSucursal'
import SEDatosProductoSuma from './SEDatosProductoSuma'
import './styles/SEDatosProducto.css'
import ImgServicio from '../../../../media/felsv/dark_reader_icon.svg'
import ImgProducto from '../../../../media/felsv/dark_box_icon.svg'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import useUtilsDocs, { esCatalogoProductoByTipo } from '../../../../actions/utils-documentos.actions'
import InputForm from '../../../OtrosDocumentos/Components/InputFormV2'

const SEDatosProducto = (props: any) => {
  const formProducto = useSelector((state: State) =>props.editar ? state.sujetoExcluido.formProductosEdit : state.sujetoExcluido.formProductos)
  const errors = useSelector((state: State) => props.editar ? state.sujetoExcluido.errorsFormProductosEdit : state.sujetoExcluido.errorsFormProductos)
  const idDoc = "14";
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionSujetoExcluidoProducto, dispatch)
  const {unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
  const {processFormCatalogoProducto} = useUtilsDocs();
  const [customDescripcion, setCustomDescripcion] = useState(props.editar ? !formProducto.clave : false);

  useEffect(() => {
    acciones.sujetoExcluidoFormProductoUpdateCalculo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProducto.cantidad, formProducto.precio, formProducto.descuento, formProducto.tipoDescuento,])

  const agregarProducto = (e: any) => {
    e.preventDefault()
    setCustomDescripcion(false);
    acciones.sujetoExcluidoFormProductoAddProducto()
  }

  const close = () => {
    if (props.editar) dispatch(acciones.sujetoExcluidoCloseModalEditar())
    else dispatch(acciones.sujetoExcluidoFormProductoClear())
    setCustomDescripcion(false);
  }
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.sujetoExcluidoFormProductoHandleChangeInput(e)
    acciones.sujetoExcluidoFormProductoValidacionesOnBlur(e)
    if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
  }

  const handleSelectCatalogoProducto = (e: any) => {
    let newFormProducto = {...formProducto};
    if (e.label != -1) {
      newFormProducto = processFormCatalogoProducto(idDoc, formProducto, e.value);
    }
    else {
      newFormProducto = {...newFormProducto, descripcion: e.value, clave: ''};
      setCustomDescripcion(true);
    }

    acciones.sujetoExcluidoFormProductoHandleChange(newFormProducto);
    acciones.sujetoExcluidoFormProductoValidacionesOnBlur({target: {name: 'descripcion', value: e.value}})
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        {!props.editar && <SEDatosSucursal />}
        <form className='form-content' onSubmit={agregarProducto} autoComplete='off'>
          <div>
            <h3 className='card-title l'>PRODUCTO Ó SERVICIO</h3>
            <div className='form-separator'></div>
          </div>
          <TipoProducto editar={props.editar} />
          <div className='w-layout-hflex h-inputs'>
            {
              (!customDescripcion && productosCatalogo.length > 0)
              ? (
                <InputForm enableCreate={true} required type = 'select' options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.tipo === "s", prod))} keyNameText = 'descripcion' keyNameValue = 'clave' onChange = {handleSelectCatalogoProducto} label = 'Descripción' value = {formProducto?.clave} error = {errors.descripcion}/>
              )
              : (
                <div className='label-input'>
                  <label htmlFor='descripcion' className='field-label m'>Descripción<span style={{color: 'red'}}>*</span></label>
                  <input autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='descripcion'
                    data-name=''
                    placeholder='Descripción del producto'
                    id='descripcion'
                    maxLength={100}
                    value={formProducto.descripcion}
                    onChange={handleChange}
                    onBlur={acciones.sujetoExcluidoFormProductoValidacionesOnBlur}
                  />
                  {errors.descripcion && <p className='alert s'>{errors.descripcion}</p>}
                </div>
              )
            }
          </div>
          <div className={`ef-form-producto-div4${props.editar ? '-modal' : ''}`}>
            <div className='label-input'>
              <label htmlFor='cantidad' className='field-label m'>Cantidad<span style={{color: 'red'}}>*</span></label>
              <input autoComplete='off'
                type='text'                
                className='m text-field w-input'
                name='cantidad'
                data-name=''
                placeholder='0'
                id='cantidad'
                maxLength={13}
                value={formProducto.cantidad}
                onChange={handleChange}
              />
              {errors.cantidad ? (<p className='alert s'>{errors.cantidad}</p> ) : errors.precio || errors.tipoDescuento || errors.descuento ? (<p className='alert s'>&nbsp;</p> ) : ('')}
            </div>
            <div className='label-input'>
              <label htmlFor='unidadMedida' className='field-label m'>
                Unidad de medida
              </label>
              <SearchSelect
                data={unidadesMedida}
                keyNameText='valor'
                keyNameValue='codigo'
                placeholder='Unidad de medida'
                value={formProducto.unidadMedida}
                onChange={(e: any) => handleChange({target: {value: e.value, name: 'unidadMedida'}})}
                name='unidadMedida'
                disabled = {false}
              />
              {/* <select
                id='unidadMedida'
                name='unidadMedida'
                data-name=''
                className='m text-field w-select'
                value={formProducto.unidadMedida}
                onChange={handleChange}
                onBlur={acciones.facturacionFormProductoValidacionesOnBlur}
              >
                <option value='porcentaje'>Porcentaje</option>
                <option value='monto'>Monto</option>
              </select> */}
              {errors.tipoDescuento ? (<p className='alert s'>{errors.tipoDescuento}</p>) : errors.cantidad || errors.precio || errors.descuento ? (<p className='alert s'>&nbsp;</p>) : ('')}
          </div>
            <div className='label-input'>
              <label htmlFor='precio' className='field-label m'>Precio con IVA<span style={{color: 'red'}}>*</span></label>
              <input autoComplete='off'
                type='text'                
                className='m text-field w-input'
                name='precio'
                data-name=''
                placeholder='0.00'
                id='precio'
                value={formProducto.precio}
                onChange={handleChange}
              />
              {errors.precio ? (<p className='alert s'>{errors.precio}</p>) : errors.cantidad || errors.tipoDescuento || errors.descuento ? (<p className='alert s'>&nbsp;</p>) : ('')}
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDescuento' className='field-label m'>Tipo de desc.</label>
              <select
                id='tipoDescuento'
                name='tipoDescuento'
                data-name=''
                className='m text-field w-select'
                value={formProducto.tipoDescuento}
                onChange={handleChange}
              >
                <option value='porcentaje'>Porcentaje</option>
                <option value='monto'>Monto</option>
              </select>
              {errors.tipoDescuento ? (<p className='alert s'>{errors.tipoDescuento}</p>) : errors.cantidad || errors.precio || errors.descuento ? (<p className='alert s'>&nbsp;</p>) : ('')}
            </div>
            <div className='label-input'>
              <label htmlFor='descuento' className='field-label m'>Descuento</label>
              <InputIcon
                darkIcon={formProducto.tipoDescuento === 'porcentaje' ? DarkPorcentaje : DarkDollar}
                secondaryIcon={formProducto.tipoDescuento === 'porcentaje' ? SecondaryPorcentaje : DollarSecondary }
                type='text'                
                className={`text-field-icon2 ${formProducto.tipoDescuento === 'porcentaje' ? 'porcentaje' : 'dollar'} w-input`}
                name='descuento'
                data-name=''
                placeholder='0.00'
                id='descuento'
                value={formProducto.descuento}
                onChange={handleChange}
              />
              {errors.descuento ? (<p className='alert s'>{errors.descuento}</p>) : errors.cantidad || errors.precio || errors.tipoDescuento ? (<p className='alert s'>&nbsp;</p>) : ('')}
            </div>
          </div>
          
          <div className='form-separator'></div>
          <SEDatosProductoSuma
            subtotal={formProducto.subtotal}
            descuento={formProducto.cantidadDescuento}
            total={formProducto.total}
          />

          <div className='w-layout-hflex button-actions'>
            <button type='button' className='m button transparent w-inline-block' onClick={close}>
              <div>{props.editar ? 'Cancelar' : 'Limpiar'}</div>
            </button>
            <button type='submit' className='m button w-inline-block'>
              <div>{props.editar ? 'Actualizar' : 'Agregar'}</div>
              {props.editar ? (<img src={WhiteCheck} loading='lazy' alt='Generar' />) : (<img src={WhitePlus} loading='lazy' alt='Agregar' />)}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SEDatosProducto


const TipoProducto = (props: any) => {
  const formProducto = useSelector((state: State) =>props.editar ? state.sujetoExcluido.formProductosEdit : state.sujetoExcluido.formProductos)
  const {tipoDocumento} = useSelector((state: State) => state.sujetoExcluido.formCliente)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionSujetoExcluidoProducto, dispatch)

  const handleChangeTipo = (value: string) => {
    acciones.sujetoExcluidoFormProductoHandleChangeInput({target: {name: "tipo", value}})
  }

  return (
    <div className='label-input'>
      <label htmlFor='tipo' className='field-label m'>Tipo de producto</label>
      <div className='div-block'>
        <button type='button' className={`product-type w-inline-block div-button ${ formProducto.tipo === 'p' ? 'product-type-active' : ''}`} onClick={() => handleChangeTipo('p')}>
          <img src={ImgProducto} loading='lazy' alt='Producto' />
          <div>Producto</div>
        </button>
        {(tipoDocumento === "" || tipoDocumento === "sinDocumento" || tipoDocumento === "37") ? <div className="product-type w-inline-block div-button" style={{visibility:"hidden"}}></div> 
        : <button type='button' className={`product-type w-inline-block div-button ${ formProducto.tipo === 's' ? 'product-type-active' : ''}`} onClick={() => handleChangeTipo('s')} >
          <img src={ImgServicio} loading='lazy' alt='Servicio' />
          <div>Servicio</div>
        </button>}
      </div>
    </div>
  )
}
